export function initContentWithGrid() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=content-with-grid',
            contentWithGrid
        );
    }
}

export function contentWithGrid() {
    if (!document.querySelector('.column-grid')) return false;

    resizer();

    window.addEventListener('resize', resizer);

    function resizer() {

        let three_column_stats_blocks = document.querySelectorAll('.column-grid');

        [...three_column_stats_blocks].forEach((v,i,a) => {
            let height = 0;
            let columns = v.querySelectorAll('.column');
            [...columns].forEach((val,ind,arr) => {
                val.querySelector('.heading').style.height = '';
                let pHeight = val.querySelector('.heading').getBoundingClientRect().height;
                if(pHeight > height) {
                    height = pHeight;
                }
            });
            [...columns].forEach((val,ind,arr) => {
                val.querySelector('.heading').style.height = height + 'px';
            });
        });
    }
}
